var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "collect-del" }, [
    _c("div", { staticClass: "dialog-body del-body" }, [
      _c("i", { staticClass: "el-icon-warning" }),
      _c("div", { staticClass: "del-cont" }, [
        _c("div", { staticClass: "tips1" }, [_vm._v(_vm._s(_vm.tips1))]),
        _c("div", { staticClass: "tips2" }, [_vm._v(_vm._s(_vm.tips2))])
      ])
    ]),
    _c("div", { staticClass: "dialog-footer" }, [
      _c("input", {
        staticClass: "btn cancelOrRestBtnHover",
        attrs: { type: "button", value: "取消" },
        on: {
          click: function($event) {
            return _vm.cancle()
          }
        }
      }),
      _c("input", {
        staticClass: "btn btn-red",
        attrs: { type: "button", value: "确认" },
        on: {
          click: function($event) {
            return _vm.commit()
          }
        }
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }